import { connect } from 'react-redux';
import CompanyInfo from '../views/JobViewPublic/components/CompanyInfo';
import {
  currentCompanyNameSelector,
  currentCompanySelector,
  draftCompanyUpdated
} from '../redux/features/company/companiesSlice';
import { currentFileLogoUrlSelector } from '../redux/features/file/filesSlice';

const mapStateToProps = (state) => {
  return {
    name: currentCompanyNameSelector(state),
    fileLogoUrl: currentFileLogoUrlSelector(state),
    companyInfo: currentCompanySelector(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickInfo: (company) => {
      // Update draft company when clicked so the editor can load it
      if (company) {
        dispatch(draftCompanyUpdated({ company }));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyInfo);
